import { EnvironmentType } from '../../types/environment.types.ts';

export const ENVIRONMENT_SLICE_NAME = 'environment';

export interface EnvironmentSliceState {
  selectedEnvironment?: EnvironmentType;
  isLoading: boolean;
}
